import type {CompanyReport} from '@/types'

const initialState: CompanyReport = {
  isLoading: false,
}

export default (state: CompanyReport = initialState, action): CompanyReport => {
  const {type, payload} = action

  switch (type) {
    case 'GET_COMPANY_REPORT':
      return {
        ...state,
        companyReport: {},
        isLoading: true,
        error: '',
      }
    case 'GET_COMPANY_REPORT_SUCCESS':
      return {
        ...state,
        isLoading: false,
        companyReport: {...payload},
        error: payload.messages ? {messages: payload.messages} : '',
      }
    case 'GET_COMPANY_REPORT_FAILURE':
      return {
        ...state,
        isLoading: false,
        error: payload.data || {message: 'Service is unavailable, please try again later.'}, // TODO: remove this when api fixes
      }
    case 'LOG_OUT':
      return initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/report/reducer.js